import { useNavigate, useParams } from 'react-router-dom';
import { DEFAULT_LANG, LANGUAGES, isValidLang } from './taxi-i18n';

export default function TaxiLanguageSelector({ label }) {
  const { lang } = useParams();
  const navigate = useNavigate();
  const currentLang = isValidLang(lang) ? lang : DEFAULT_LANG;

  function handleChange(nextLang) {
    const path =
      nextLang === DEFAULT_LANG ? '/demo/taxi-radenovic' : `/demo/taxi-radenovic/${nextLang}`;
    navigate(path);
  }

  return (
    <div className="taxi-lang">
      <label className="taxi-lang-label" htmlFor="taxi-lang-select">
        {label}
      </label>
      <select
        id="taxi-lang-select"
        className="taxi-lang-select"
        value={currentLang}
        onChange={(e) => handleChange(e.target.value)}
        aria-label={label}
      >
        {LANGUAGES.map((language) => (
          <option key={language.code} value={language.code}>
            {language.flag} {language.label}
          </option>
        ))}
      </select>
    </div>
  );
}
